
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

// const stripePromise = loadStripe("your-publishable-key");

function CheckoutForm({ clientSecret,twoFactAuth,twoFactAuthFail }) {
  const stripe = useStripe();
  const elements = useElements();
  // Automatically confirm card payment when clientSecret, stripe, or elements change
  React.useEffect(() => {
    const confirmPayment = async () => {
      if (!stripe || !clientSecret) return;
    //   console.log("Client Secret:", clientSecret);
      const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret);
      if (error) {
        console.error(error.message);
        twoFactAuthFail(error.message);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        twoFactAuth(paymentIntent);
        
      }
    };
    confirmPayment();
  }, [clientSecret, stripe, elements]);


  return (
<div></div>
  );
}

export default function App({ clientSecret,twoFactAuth,twoFactAuthFail }) {

  return (
    // <Elements stripe={stripePromise}>
      <CheckoutForm clientSecret={clientSecret} twoFactAuth={twoFactAuth} twoFactAuthFail={twoFactAuthFail}/>
    // </Elements>
  );
}
